module.exports = __webpack_public_path__ + "img/draft-gray.eb7c9d93.svg";